import { ToastState, SetToastsPayload } from '@/global/toast/store/types'

export const setToasts = (
  state: ToastState,
  { toasts }: SetToastsPayload
): void => {
  state.toasts = toasts
}
